import { Layouts } from "react-grid-layout";

export const isLayoutInvalid = (firstLayout: Layouts) => {
  return Object.entries(firstLayout).some(([, layout]) =>
    layout.some((l) => l.w === 1 || l.h === 1),
  );
};
